import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    blockHeading: p => p.accentWhite,
    subTitle: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    dateText: p => p.accentWhite,
    backgroundColor: p => p.tertiaryDark,
    cardBackgroundColor: p => p.tertiaryDark,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.15)`,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    blockHeading: p => p.primaryDark,
    subTitle: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    dateText: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryLight,
    cardBackgroundColor: p => p.tertiaryLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.15)`,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    blockHeading: p => p.tertiaryDark,
    subTitle: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    dateText: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryExtraLight,
    cardBackgroundColor: p => p.tertiaryExtraLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.15)`,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`
  }
}
